const splideOptions = {
  gap: 16,
  arrows: false,
  focus: 'center',
  perPage: 1,
  fixedWidth: 310,
  padding: {
    left: 30,
    right: 30,
  },
  mediaQuery: 'min',
  breakpoints: {
    768: {
      destroy: true,
      pagination: false,
    },
  },
};

const selectors = {
  grid: '[data-grid-slider]',
};

export { splideOptions, selectors };
